type Props = {
  canSave: boolean;
  saving: boolean;
  readOnly?: boolean;
  onSave: () => void;
  onCancel: () => void;
};

/** Shared Save / Cancel actions for Case Update step sections. */
export default function TaskCaseUpdateSectionActions({
  canSave,
  saving,
  readOnly = false,
  onSave,
  onCancel,
}: Props) {
  if (readOnly) return null;
  return (
    <div className="tcd-step-actions">
      <button type="button" className="ccr-btn-pr" disabled={!canSave || saving} onClick={onSave}>
        {saving ? 'Saving…' : 'Save'}
      </button>
      <button type="button" className="ccr-btn-ol" disabled={saving} onClick={onCancel}>
        Cancel
      </button>
    </div>
  );
}
